import { render, staticRenderFns } from "./Semesters.vue?vue&type=template&id=14280682&scoped=true&"
import script from "./Semesters.vue?vue&type=script&lang=js&"
export * from "./Semesters.vue?vue&type=script&lang=js&"
import style0 from "./Semesters.vue?vue&type=style&index=0&id=14280682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14280682",
  null
  
)

export default component.exports